import { Component, Inject } from "@angular/core";

import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";

import Swal from "sweetalert2";

import { Router } from "@angular/router";
import { AppLoaderService } from "../../../../../services/app-loader/app-loader.service";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";

@Component({
  template: require('./view-history-popup.component.html'),
  styles: [require('./view-history-popup.component.css')],
  selector: "view-history-popup",
})
export class ViewSyncItHistoryComponent {
  dialogTitle = "View License History";
  errorMessage = "";
  SyncITProductLicenseId: any;
  SyncItLicenseHistory: any;
  isLoading = false;
  constructor(
    private licenseService: LicenseService,
    public dialogRef: MdDialogRef<ViewSyncItHistoryComponent>,
    public appLoader: AppLoaderService,
    private adalService: AdalService,
    private router: Router,
    @Inject(MD_DIALOG_DATA) public dialogData: any
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.SyncITProductLicenseId = this.dialogData.SyncITProductLicenseId;
    this.getHistory();
  }

  getHistory() {
    this.isLoading = true;
    this.licenseService
      .getSyncITLicenseHistory(this.SyncITProductLicenseId)
      .subscribe({
        next: (data: any) => {
          if (!data.IsError) {
            this.SyncItLicenseHistory = data.DataObject; // <-- use DataObject
          } else {
            this.errorMessage = data.Error || "Failed to fetch history";
          }
          this.isLoading = false;
        },
        error: (err) => {
          this.errorMessage = "Error fetching license history";
          this.isLoading = false;
        },
      });
  }

  copyToClipboard(text: string) {
    if (!navigator.clipboard) {
      // fallback for older browsers
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      alert("Copied to clipboard!");
      return;
    }

    navigator.clipboard.writeText(text).then(
      () => {
        
      },
      (err) => {
        console.error("Could not copy text: ", err);
      }
    );
  }

  onCancel() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/popup/view-history-popup/view-history-popup.component.ts